import { render, staticRenderFns } from "./SourceUrl.vue?vue&type=template&id=f5727b4e&"
import script from "./SourceUrl.vue?vue&type=script&lang=js&"
export * from "./SourceUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports